import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import InputMask from 'react-input-mask';

const PropTypes = require('prop-types');

class ExamOpenedAcoes extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      exam_date: '',
      hora_inicial: '',
      hora_final: '',
      exam_start: '',
      exam_finish: '',
      modal: false,
      modal_input: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
      questao: {},
      questoes: {},
      archive: '',
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
      result: '',
      result_manual: 0,
      active: '',
    };
    //bind geral
    this.showModal = this.showModal.bind(this);
    this.showModalInput = this.showModalInput.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.downloadExam = this.downloadExam.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.finishExam = this.finishExam.bind(this);
    this.resultManual = this.resultManual.bind(this);
    this.resultManualActive = this.resultManualActive.bind(this);
    this.resultManualInactive = this.resultManualInactive.bind(this);
    this.trocarActive = this.trocarActive.bind(this);
    this.getNow = this.getNow.bind(this);
  }

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeResult (name, event) {
    var change = {};
    if(event.target.value > 100) {
      change[name] = 100;
    } else {
      change[name] = event.target.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  trocarActive () {
    var toggle = this.state.active;
    var datasave = {
      id: this.props.dadosProva.id,
      active: 0,
    };
    var confirmacao = window.confirm('Tem certeza que deseja arquivar essa prova?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/change_active', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshTable(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  getNow() {
    var currentdate = new Date();
    var datetime = ("0" + currentdate.getDate()).slice(-2) + "/"
                    + ("0" + (currentdate.getMonth()+1)).slice(-2)  + "/"
                    + currentdate.getFullYear() + " "
                    + currentdate.toLocaleTimeString('en-GB', { hour: "numeric", minute: "numeric"})
                    + ':00';
    return datetime;
  }

  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes () {
    var self = this;
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({questao: questao});
      this.setState({opcoes: opcoes});
    }
  }

  downloadExam () {
    var self = this;
    self.props.handleAlert('', '', 'open');
    var url = config.get('api') + '/download/prova/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  finishExam() {
    var self = this;
    var data = new FormData();
    var imagedata = document.querySelector(".input-archive").files[0];
    if(typeof imagedata !== 'undefined'){
      if (window.confirm('Tem certeza que deseja finalizar esta prova? Essa ação é irreversível!')) {
        self.props.handleAlert('', '', 'open');
        var data = new FormData();
        var questoes = this.state.questoes.map(function(value, index) {
            var questao_id = "questoes[" + index + "][id]";
            var questao_team_training_matter_staff_exam_id = "questoes[" + index + "][team_training_matter_staff_exam_id]";
            var questao_selected = "questoes[" + index + "][selected]";
            data.append(questao_id, value.id);
            data.append(questao_team_training_matter_staff_exam_id, value.team_training_matter_staff_exam_id);
            data.append(questao_selected, value.selected);

            var questoes_options = value.team_training_matter_staff_exam_question_option.map(function(value_2, index_2) {
              var team_training_matter_staff_exam_question_option = "questoes[" + index + "][team_training_matter_staff_exam_question_option][" + index_2 + "][id]";
              data.append(team_training_matter_staff_exam_question_option, value_2.id);
            });

        });
        data.append("exam_start", this.state.exam_start);
        data.append("exam_finish", this.state.exam_finish);
        data.append("imagem", imagedata);
        var header = this.refs.request_api.header();
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/finalizar/prova/manual', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                self.props.loadData();
                setTimeout(function(){ self.props.handleAlert(responseJson.message, responseJson.status, 'open'); }, 800);
              } else  {
                self.props.handleAlert(responseJson.message, responseJson.status, 'open');
              }
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
            console.error(error);
          });
        });
      }
    } else {
      self.props.handleAlert('Selecione um arquivo.', 'error', 'open');
    }
  }

  resultManual() {
    var self = this;
    var data = new FormData();
    var imagedata = document.querySelector(".input-archive").files[0];
    data.append("id", self.props.dadosProva.id);
    data.append("result", this.state.result);
    data.append("exam_start", this.state.exam_start);
    data.append("exam_finish", this.state.exam_finish);
    data.append("imagem", imagedata);
    if(typeof imagedata !== 'undefined'){
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header();
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/resultado/manual', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.props.loadData();
              setTimeout(function(){ self.props.handleAlert(responseJson.message, responseJson.status, 'open'); }, 800);
            } else  {
              setTimeout(function(){ self.props.handleAlert(responseJson.message, responseJson.status, 'open'); }, 800);
            }
          }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      self.props.handleAlert('Selecione um arquivo.', 'error', 'open');
    }
  }

  resultManualActive() {
    this.setState({ result_manual: 1 });
  }
  resultManualInactive() {
    this.setState({ result_manual: 0 });
  }

  selectOption(index_1, index_2) {
    var questoes = this.state.questoes
    Object.keys(questoes).map(function(k) {
      Object.keys(questoes[k].team_training_matter_staff_exam_question_option).map(function(i) {
        if (index_1 === k && index_2 === i) {
          var opcao_str = questoes[k].team_training_matter_staff_exam_question_option[i].option_number.toUpperCase();
          questoes[k].team_training_matter_staff_exam_question_option[i].selected = 1;
          questoes[k].selected = questoes[k].team_training_matter_staff_exam_question_option[i].option_number;
          questoes[k].selected_str = opcao_str;
        } else if (index_1 === k && index_2 !== i) {
          questoes[k].team_training_matter_staff_exam_question_option[i].selected = 0;
        }
      });
    });
    this.setState({questoes: questoes});
  }

  showModal(event) {
    this.props.handleAlert('', '', 'open');
    this.setState({ modal: true }, this.buscarQuestoes());
  }

  showModalInput(event) {
    this.props.handleAlert('', '', 'open');
    this.setState({ modal_input: true }, this.buscarQuestoes());
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <button onClick={this.trocarActive} className='btn btn-xs btn-success' alt='Trocar para arquivado' title="Trocar para arquivado"><i className="fa fa-fw fa-power-off"></i></button>
  <button alt="Inputar prova" title="Inputar prova" onClick={this.showModalInput} className='btn btn-primary btn-xs'><i className="fa fa-fw fa-tasks"></i></button>
  <button alt="Download de prova" title="Imprimir prova" onClick={this.downloadExam} className='btn btn-info btn-xs'><i className="fa fa-fw fa-print"></i></button>
  <Modal show={this.state.modal_input} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Revisão de prova do aluno: {this.props.dadosProva.staff}</b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_input: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row dados-prova-modal">
        <div className="col-md-6">
            <p><b>Código: </b>{this.props.dadosProva.id}</p>
            <p><b>Treinamento: </b>{this.props.dadosProva.training}</p>
            <p><b>Matéria: </b>{this.props.dadosProva.matter}</p>
            <p><b>Status: </b><span className={(self.props.dadosProva.status == 'confirmada') ? 'label-primary' : 'label-info'}>{(self.props.dadosProva.status == 'confirmada') ? 'Confirmada' : 'Aberta'}</span></p>
            <br/>
            <p><b>Início: </b></p>
            <div className="input-group">
              <InputMask maskChar={null} mask="99/99/9999 99:99" type="text" name="name" placeholder="dd/mm/aaaa hh:mm" value={this.state.exam_start} onChange={this.handleChange.bind(this, 'exam_start')} className="form-control" />
              <div className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_start: this.getNow()})}><i className="fa fa-calendar"></i></div>
            </div>
            <br/>
            <p><b>Fim: </b></p>
            <div className="input-group">
              <InputMask maskChar={null} mask="99/99/9999 99:99" type="text" name="name" placeholder="dd/mm/aaaa hh:mm" value={this.state.exam_finish} onChange={this.handleChange.bind(this, 'exam_finish')} className="form-control" />
              <div className="input-group-addon" style={{cursor: 'pointer'}} onClick={() => this.setState({exam_finish: this.getNow()})}><i className="fa fa-calendar"></i></div>
            </div>
            <br/>
            <p><b>Arquivo de prova externa: </b><input type="file" name="archive" className="input-archive" placeholder="Arquivo" value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} /></p>
            <br/>
            {self.state.result_manual == 0 ?
              <div>
                <p><button className="btn btn-sm btn-primary" onClick={() => { self.resultManualActive() }}><i className="fa fa-fw fa-check"></i> Inserir nota manualmente</button></p>
                <br/>
              </div>
              :
                <p><button className="btn btn-sm btn-primary" onClick={() => { self.resultManualInactive() }}><i className="fa fa-fw fa-check"></i> Liberar questões</button></p>
            }
            {self.state.result_manual == 1 ?
              <div>
                <br/>
                <p><b>Nota: </b><InputMask value={this.state.result} type="text" maskChar={null} name="result" mask="999" onChange={this.handleChangeResult.bind(this, 'result')} placeholder="Somente números" /></p>
                <br/>
                <p><button className="btn btn-sm btn-primary" onClick={() => { self.resultManual() }}><i className="fa fa-fw fa-check"></i> Inserir manualmente</button></p>
              </div>
              : ""
            }
        </div>
        <div className="col-md-6">
            <p><b>Total de questões: </b>{this.props.dadosProva.qtd_questoes}</p>
            <p><b>Acertos: </b>{this.props.dadosProva.qtd_acertadas}</p>
            <p><b>Erros: </b>{this.props.dadosProva.qtd_erradas}</p>
            <p><b>Nota: </b>{this.state.result_manual == 0 ? this.props.dadosProva.result : this.state.result}</p>
        </div>
      </div>
      <hr/>
      {self.state.result_manual == 0 ?
        <div>
          {Object.keys(self.state.questoes).map(function(k) {
            return (
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <h3>Questão {self.state.questoes[k].question_number}:</h3>
                  </div>
                  <div className="col-md-6 text-right">
                    <h3>Cod. {self.state.questoes[k].question.number}</h3>
                  </div>
                </div>
                <hr/>
                <div dangerouslySetInnerHTML={{__html: self.state.questoes[k].question_content}}></div>
                <hr/>
                <h3 className="text-center">Opção correta: <span className="opcao-correta">{self.state.questoes[k].option_correct_number}</span></h3>
                <hr/>
                <table className="table tabela-questao-opcoes">
                  <tbody>
                    {Object.keys(self.state.questoes[k].team_training_matter_staff_exam_question_option).map(function(i) {
                      var opcao =  (self.state.questoes[k].team_training_matter_staff_exam_question_option[i]);
                      return (
                        <tr>
                          <td className="checkbox-questao-opcoes" onClick={() => { self.selectOption(k, i) }}>
                            <div className={(opcao.selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(opcao.selected == 1) ? 'X' : ''}</div>
                          </td>
                          <td>
                            <span>{opcao.option_number}) </span>{opcao.option_name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <hr/>
              </div>
            );
          })}
          <button className="btn btn-block btn-lg btn-primary" onClick={() => { self.finishExam() }}><i className="fa fa-fw fa-check"></i> Finalizar prova</button>
        </div>
        :
        ""
      }
    </Modal.Body>
    <Modal.Footer className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_input: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

ExamOpenedAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamOpenedAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamOpenedAcoes.js